import { createBrowserRouter, createHashRouter, RouterProvider } from "react-router";
import { routes } from "../../routes/routes";
import { Suspense } from "react";

function RouteProvider() {
  // const router = createHashRouter(routes);
  const router = createBrowserRouter(routes, {
    basename: "/",
  });

  return (
    <Suspense fallback={null}>
      <RouterProvider router={router} />
    </Suspense>
  );
}

export default RouteProvider;
